import { Controller } from "@hotwired/stimulus";
import { fetchStream } from "../../utils/turbo_utils";

export default class extends Controller {
  static targets = ["loader"];
  static values = { url: String };

  reload() {
    this.loaderTarget.classList.remove("hidden");
    fetchStream(this.urlValue).finally(() => {
      this.loaderTarget.classList.add("hidden");
    });
  }
}
